
export class City {
	constructor(
        public cityID: number,
		public cityName: string,

		public districtID?: number,
		public districtName?: string,

		public municipalityID?: number,

		public municipalityName?: string

	) { 
	}

}


// WEBPACK FOOTER //
// ./src/app/city.ts